import { jsx as _jsx } from "react/jsx-runtime";
import { useHighlight } from '../../../highlight/index';
import { useFormatNumberByNucleus } from '../../../hooks/useFormatNumberByNucleus';
const styles = {
    container: {
        position: 'inherit',
        padding: '0.15rem 0.4rem',
    },
    errorLabel: {
        color: 'red',
    },
};
function AnalysisCell({ columnKey, value, activeTab }) {
    const highlight = useHighlight([columnKey]);
    const format = useFormatNumberByNucleus(activeTab);
    return (_jsx("div", { style: { ...styles.container, ...highlight.defaultActiveStyle }, ...highlight.onHover, children: value instanceof Error ? (_jsx("span", { style: styles.errorLabel, children: value.message })) : (format(value)) }));
}
export default AnalysisCell;
